export default {
  data() {
    return {
      showTime: 5000, // 每幾秒播放下一張
      activeIndex: 0,
      play: null,
      isClicked: false, // 使用者點擊過左右按鈕後 跳過一次自動播放
      locked: false, // 防止連點
    };
  },
  computed: {
    isOnly() {
      return this.carouselItem.length === 1;
    },
  },
  methods: {
    itemStatus(index, activeIndex) {
      const length = this.fullItems.length;
      switch (activeIndex) {
        case index:
          return 'on';

        case index + 1:
        case index + 1 - length:
          return 'last';

        case index - 1:
        case index - 1 + length:
          return 'next';

        default:
          return '';
      }
    },
    inRange(value) {
      if (value >= this.fullItems.length) return 0;
      if (value < 0) return this.fullItems.length - 1;
      return value;
    },
    carouselPlay() {
      if (this.isOnly) return;

      this.play = setInterval(() => {
        if (this.isClicked) return (this.isClicked = false);
        this.activeIndex = this.inRange(this.activeIndex + 1);
      }, this.showTime);
    },
    slide(value) {
      if (this.locked || this.isOnly) return;
      this.activeIndex = this.inRange(this.activeIndex + value);
      this.isClicked = true;
      this.locked = true;
      setTimeout(() => (this.locked = false), 500);
    },
    next() {
      this.slide(1);
    },
    prev() {
      this.slide(-1);
    },
  },
  mounted() {
    this.carouselPlay();
  },
  beforeDestroy() {
    clearInterval(this.play);
  },
};
